import React from 'react';
import styles from "./style.module.scss";

export default function icon(props) {

    return (
        <img src={"./site_images/icon/"+props.icon} width={props.width} height={props.height}/>
    );
}
